export enum CartActionType {
  AddItem = "ADD_TO_CART",
  RemoveItem = "REMOVE_CART_ITEM",
  EditItemAmount = "TOGGLE_CART_ITEM_AMOUNT",
  ClearCart = "CLEAR_CART",
  CountTotal = "COUNT_CART_TOTALS",
}

export enum ProductsActionType {
  GetProductsBegin = "GET_PRODUCTS_BEGIN",
  GetProductsSuccess = "GET_PRODUCTS_SUCCESS",
  GetProductsError = "GET_PRODUCTS_ERROR",
  GetSingleProductBegin = "GET_SINGLE_PRODUCT_BEGIN",
  GetSingleProductSuccess = "GET_SINGLE_PRODUCT_SUCCESS",
  GetSingleProductError = "GET_SINGLE_PRODUCT_ERROR",
}

export enum RecActionType {
  GetStyleRecommendationBegin = "GET_STYLE_RECOMMENDATION_BEGIN",
  GetStyleRecommendationSuccess = "GET_STYLE_RECOMMENDATION_SUCCESS",
  GetStyleRecommendationError = "GET_STYLE_RECOMMENDATION_ERROR",
}
